<i18n src="./resources/locales.json"></i18n>

<template>
  <EcsDashboardCard @resize="expanded => $emit('resize', expanded)">
    <div class="title-container">
      <div v-once class="card-title xtium-title">
        {{ $t('agentSummary') }}
      </div>

      <v-spacer />

      <v-text-field
        v-model="search"
        prepend-inner-icon="search"
        label="Search"
        single-line
        hide-details
        class="search-text-field"
        :class="{ expanded: isExpanded }"
        @focus="toggleExpandedSearch"
        @blur="toggleExpandedSearch"
      />
    </div>

    <v-data-table
      :headers="headers"
      :items="FORMATTED_AGENTS_STATS"
      :search="search"
      :class="`custom-scrollbar`"
      dense
    />
  </EcsDashboardCard>
</template>

<script>
import { mapGetters } from 'vuex';
import EcsDashboardCard from '@/components/ecs-dashboard-card/EcsDashboardCard';
import EcsKpiFormatter from '@/mixins/ecs-kpi-formatter/EcsKpiFormatter';

export default {
  name: 'EcsAgentsSummaryCard',

  components: { EcsDashboardCard },

  mixins: [EcsKpiFormatter],

  data() {
    return {
      search: '',
      expanded: false,
      expandedSearch: false,
      headers: [
        {
          text: 'Name',
          align: 'left',
          sortable: false,
          value: 'agentName',
          width: 160
        },
        { text: 'Handled', value: 'agentAverageTreatingTime', width: 80 },
        { text: 'Break', value: 'agentBreakTime', width: 80 },
        { text: 'ASA', value: 'agentASA', width: 80 },
        { text: 'Missed', value: 'agentMissedCalls', width: 80 },
        { text: 'Idle', value: 'agentTotalIdleTime', width: 80 }
      ]
    };
  },

  computed: {
    ...mapGetters('STATS', ['AGENTS_STATS']),

    FORMATTED_AGENTS_STATS() {
      return this.AGENTS_STATS.map(item => {
        return {
          agentName: item.agentName,
          agentAverageTreatingTime: this.kpiFormat(item.agentAverageTreatingTime.value, 'duration', true),
          agentBreakTime: this.kpiFormat(item.agentBreakTime.value, 'duration', true),
          agentASA: this.kpiFormat(item.agentASA.value, 'seconds', true),
          agentMissedCalls: this.kpiFormat(item.agentMissedCalls.value, 'number'),
          agentTotalIdleTime: this.kpiFormat(item.agentTotalIdleTime.value, 'duration', true)
        };
      });
    },

    isExpanded() {
      return this.expandedSearch || this.search;
    }
  },

  created() {},

  mounted() {},

  beforeDestroy() {},

  methods: {
    toggleExpandedSearch() {
      this.expandedSearch = !this.expandedSearch;
    }
  }
};
</script>

<style src="./scoped.css" scoped></style>
<style>
/*
  Adding custom scrollbar styles to inner wrappers of v-data-table
*/
.custom-scrollbar .v-data-table__wrapper {
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #b8b8b8 #4d4d4d;
}

.custom-scrollbar .v-data-table__wrapper::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 6px;
}

.custom-scrollbar .v-data-table__wrapper::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  background-color: transparent;
}

.custom-scrollbar .v-data-table__wrapper::-webkit-scrollbar-thumb {
  border-radius: 6px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #cccccc;
}

.custom-scrollbar .v-data-table__wrapper::-webkit-scrollbar-corner {
  background: transparent;
}
</style>
